import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip } from "chart.js";

ChartJS.register(ArcElement, Tooltip);

export default function GaugeWidget({
  title,
  value,
  unit,
  min = 0,
  max = 100,
  thresholds = { warning: 70, danger: 90 },
}) {
  const percentage = Math.min(100, Math.max(0, ((value - min) / (max - min)) * 100));

  let color = "#4caf50"; // green
  if (percentage >= thresholds.danger) {
    color = "#f44336"; // red
  } else if (percentage >= thresholds.warning) {
    color = "#ff9800"; // orange
  }

  const data = {
    datasets: [
      {
        data: [percentage, 100 - percentage],
        backgroundColor: [color, "#2d333b"],
        borderWidth: 0,
        circumference: 270,
        rotation: 225,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "75%",
    plugins: {
      tooltip: { enabled: false },
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.title}>{title}</div>
      <div style={styles.chartArea}>
        <div style={styles.chartWrapper}>
          <Doughnut data={data} options={options} />
          <div style={styles.valueOverlay}>
            <span style={{ ...styles.value, color }}>{value}</span>
            <span style={styles.unit}>{unit}</span>
          </div>
        </div>
        <div style={styles.range}>
          <span>{min}</span>
          <span>{max}</span>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    backgroundColor: "#161b22",
    borderRadius: "8px",
    padding: "4px",
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxSizing: "border-box",
    overflow: "hidden",
  },
  title: {
    color: "#8b949e",
    fontSize: "11px",
    flexShrink: 0,
  },
  chartArea: {
    flex: 1,
    width: "100%",
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  chartWrapper: {
    position: "relative",
    width: "100%",
    height: "100%",
    maxWidth: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  valueOverlay: {
    position: "absolute",
    top: "55%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
  },
  value: {
    fontSize: "clamp(12px, 1.5vw, 20px)",
    fontWeight: "bold",
    display: "block",
  },
  unit: {
    fontSize: "clamp(8px, 1vw, 12px)",
    color: "#8b949e",
  },
  range: {
    display: "flex",
    justifyContent: "space-between",
    color: "#8b949e",
    fontSize: "9px",
    width: "80%",
    flexShrink: 0,
  },
};
